import { scaleLinear } from 'd3-scale';
import { ticks as generateTicks } from 'd3-array';
import { useMemo } from 'react';

function stepSize(ticks: number[]) {
  const length = ticks.length;
  if (length < 1) {
    return 0;
  }
  const [first, second] = ticks;
  return second - first;
}

export const useNicedTicks = (max: number, min = 0) => {
  return useMemo(() => {
    if (min === 0) {
      const ticks = scaleLinear()
        .domain([min, max])
        .nice()
        .ticks();
      const nicedMin = ticks[0];
      const nicedMax = ticks[ticks.length - 1];
      return { ticks, nicedMin, nicedMax };
    } else {
      const upperTicks = generateTicks(0, max, 5);
      const lowerTicks = generateTicks(min, 0, 5);
      const highestTick = upperTicks[upperTicks.length - 1];
      const lowestTick = lowerTicks[0];
      if (highestTick < max) {
        const step = stepSize(upperTicks);
        upperTicks.push(highestTick + step);
      }
      if (lowestTick > min) {
        const step = stepSize(lowerTicks);
        lowerTicks.unshift(lowestTick - step);
      }
      const ticks = Array.from(new Set([...lowerTicks, ...upperTicks]));
      const nicedMin = lowerTicks[0];
      const nicedMax = upperTicks[upperTicks.length - 1];
      return { ticks, nicedMin, nicedMax };
    }
  }, [min, max]);
};
